import { PublicImageItem } from '~/Nova/scenes/HostingList/utils/types';

export const osImages = {
  page: 1,
  n_rows: 8,
  limit: 1000,
  rows: [
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: null,
      current: null,
      date_added: '2025-09-19 08:45:57',
      description: 'AlmaLinux 9 base image',
      docker_default: '1',
      id: 3,
      lts: null,
      name: 'Alma 9 Base',
      os_name: 'Alma',
      os_version: '9',
      software: null,
      title: 'AlmaLinux 9',
      manage_link: null,
      links: null,
      user_image: null,
      type: 'docker',
    },
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: '1',
      current: null,
      date_added: '2025-09-19 08:46:03',
      description: 'cPanel on Alma 9',
      docker_default: null,
      id: 4,
      lts: null,
      name: 'Alma 9 Cpanel',
      os_name: 'Alma',
      os_version: '9',
      software: 'cPanel',
      title: 'cPanel on Alma 9',
      manage_link: null,
      links: null,
      user_image: null,
      type: 'cpanel',
    },
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: null,
      current: null,
      date_added: '2026-03-09 23:52:18',
      description:
        'AlmaLinux is a stable, enterprise-grade Linux distribution.',
      docker_default: null,
      id: 8,
      lts: null,
      name: 'AlmaLinux-9-GenericCloud-latest.x86_64',
      os_name: 'Alma',
      os_version: '9',
      software: null,
      title: 'AlmaLinux 9',
      manage_link: null,
      links: null,
      user_image: '1',
      type: 'base',
    },
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: null,
      current: null,
      date_added: '2026-03-09 23:52:16',
      description:
        'AlmaLinux is a stable, enterprise-grade Linux distribution.',
      docker_default: null,
      id: 7,
      lts: null,
      name: 'AlmaLinux-8-GenericCloud-latest.x86_64',
      os_name: 'Alma',
      os_version: '8',
      software: null,
      title: 'AlmaLinux 8',
      manage_link: null,
      links: null,
      user_image: '1',
      type: 'base',
    },
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: null,
      current: null,
      date_added: '2026-03-09 23:52:55',
      description: 'CentOS is a robust, enterprise-class Linux distribution.',
      docker_default: null,
      id: 24,
      lts: null,
      name: 'CentOS-Stream-GenericCloud-9-latest.x86_64',
      os_name: 'CentOS',
      os_version: '9',
      software: null,
      title: 'CentOS 9',
      manage_link: null,
      links: null,
      user_image: '1',
      type: 'base',
    },
    {
      app: null,
      arch_name: 'amd64',
      cpanel_default: null,
      current: null,
      date_added: '2026-03-09 23:52:53',
      description: 'Ubuntu is a secure, easy-to-use Linux operating system.',
      docker_default: '1',
      id: 23,
      lts: '1',
      name: 'ubuntu-24.04-minimal-cloudimg-amd64',
      os_name: 'Ubuntu',
      os_version: '24.04',
      software: null,
      title: 'Ubuntu 24.04 LTS',
      manage_link: null,
      links: null,
      user_image: '1',
      type: 'base',
    },
    {
      app: null,
      arch_name: 'amd64',
      cpanel_default: null,
      current: null,
      date_added: '2026-03-09 23:52:23',
      description:
        'Debian is a lightweight, ultra-stable Linux operating system.',
      docker_default: null,
      id: 10,
      lts: null,
      name: 'debian-12-generic-amd64',
      os_name: 'Debian',
      os_version: '12',
      software: null,
      title: 'Debian 12',
      manage_link: null,
      links: null,
      user_image: '1',
      type: 'base',
    },
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: null,
      current: null,
      date_added: '2026-03-09 23:52:37',
      description:
        'Rocky Linux is a secure, enterprise-grade Linux distribution.',
      docker_default: null,
      id: 13,
      lts: null,
      name: 'Rocky-8-GenericCloud-Base.latest.x86_64',
      os_name: 'Rocky',
      os_version: '8',
      software: null,
      title: 'Rocky Linux 8',
      manage_link: null,
      links: null,
      user_image: '1',
      type: 'base',
    },
  ],
};

export const osFilteredListMock: Record<string, PublicImageItem[]> = {
  Alma: [
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: null,
      current: null,
      date_added: '2026-01-16 19:43:24',
      docker_default: null,
      id: '9',
      lts: null,
      name: 'AlmaLinux-10-GenericCloud-latest.x86_64',
      os_name: 'Alma',
      os_version: '10',
      software: undefined,
      title: 'AlmaLinux 10',
      manage_link: null,
      links: null,
      user_image: 1,
      type: 'base',
    },
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: null,
      current: null,
      date_added: '2026-01-16 19:43:23',
      docker_default: null,
      id: '7',
      lts: null,
      name: 'AlmaLinux-8-GenericCloud-latest.x86_64',
      os_name: 'Alma',
      os_version: '8',
      software: undefined,
      title: 'AlmaLinux 8',
      manage_link: null,
      links: null,
      user_image: 1,
      type: 'base',
    },
  ],
  CentOS: [
    {
      app: null,
      arch_name: 'x86_64',
      cpanel_default: null,
      current: null,
      date_added: '2026-01-16 19:43:23',
      docker_default: null,
      id: '24',
      lts: null,
      name: 'CentOS-Stream-GenericCloud-10-latest.x86_64',
      os_name: 'CentOS',
      os_version: '10',
      software: undefined,
      title: 'CentOS 10',
      manage_link: null,
      links: null,
      user_image: 1,
      type: 'base',
    },
  ],
};
